(function(){
  'use strict';
  if(window.__shadowsMotion)return;
  window.__shadowsMotion=1;

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q=function(s,r){return(r||document).querySelector(s)};
  var qa=function(s,r){return[].slice.call((r||document).querySelectorAll(s))};
  var raf=window.requestAnimationFrame||function(fn){return setTimeout(fn,16)};

  function restart(el,cls,ms){
    if(!el||reduce)return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    if(ms)setTimeout(function(){el.classList.remove(cls)},ms);
  }

  function reveal(el,delay,observer){
    if(!el||el.dataset.sdmReveal)return;
    el.dataset.sdmReveal='1';
    if(reduce){el.classList.add('is-visible');return;}
    el.style.setProperty('--sdm-delay',(delay||0)+'ms');
    el.classList.add('sdm-reveal');
    if(observer)observer.observe(el);else raf(function(){el.classList.add('is-visible')});
  }

  function revealSystem(){
    if(reduce)return null;
    if(!('IntersectionObserver' in window))return null;
    return new IntersectionObserver(function(entries,obs){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    },{rootMargin:'0px 0px -6% 0px',threshold:.08});
  }

  function classifyProduct(root){
    var title=(q('.sdp-title',root)||q('h1',root));
    var text=(title?title.textContent:'').toLowerCase();
    if(/stamp|postage|usps|forever/.test(text))root.classList.add('sdm-product--postal');
    else if(/perfume|parfum|cologne|eau de|fragrance|sauvage|chanel|creed|tom ford|valentino|armani/.test(text))root.classList.add('sdm-product--fragrance');
  }

  function galleryMotion(root){
    var stage=q('.sdp-gallery__stage',root),img=q('.sdp-gallery__image',root);
    if(stage&&!reduce){
      stage.classList.add('sdm-gallery-enter');
      raf(function(){raf(function(){stage.classList.add('is-visible')})});
    }
    if(img&&!reduce&&window.MutationObserver){
      var last=img.getAttribute('src')||'';
      new MutationObserver(function(){
        var now=img.getAttribute('src')||'';
        if(now&&now!==last){last=now;restart(img,'sdm-image-swap',340)}
      }).observe(img,{attributes:true,attributeFilter:['src']});
    }
    if(stage&&!reduce&&window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)').matches){
      stage.classList.add('sdm-pointer-depth');
      stage.addEventListener('pointermove',function(e){
        var r=stage.getBoundingClientRect();
        var x=((e.clientX-r.left)/Math.max(1,r.width)-.5)*5;
        var y=((e.clientY-r.top)/Math.max(1,r.height)-.5)*4;
        stage.style.setProperty('--sdm-pointer-x',x.toFixed(2)+'px');
        stage.style.setProperty('--sdm-pointer-y',y.toFixed(2)+'px');
      },{passive:true});
      stage.addEventListener('pointerleave',function(){
        stage.style.setProperty('--sdm-pointer-x','0px');
        stage.style.setProperty('--sdm-pointer-y','0px');
      },{passive:true});
    }
  }

  function optionMotion(root){
    function ensureSweep(card){
      var sweep=q('.sdm-select-sweep',card);
      if(!sweep){sweep=document.createElement('span');sweep.className='sdm-select-sweep';sweep.setAttribute('aria-hidden','true');card.appendChild(sweep)}
      return sweep;
    }
    root.addEventListener('click',function(e){
      var card=e.target.closest&&e.target.closest('[data-sd-option-card],.sd-option-card');
      if(!card||!root.contains(card))return;
      ensureSweep(card);
      restart(card,'sdm-card-confirm',560);
    });
    qa('[data-sd-option-card],.sd-option-card',root).forEach(ensureSweep);
  }

  function priceMotion(root){
    var price=q('[id^="ProductPrice-"]',root)||q('.product-price__price',root);
    var compare=q('[id^="ComparePrice-"]',root);
    var targets=[price,compare].filter(Boolean);
    if(reduce||!window.MutationObserver)return;
    targets.forEach(function(el){
      var timer;
      new MutationObserver(function(){
        clearTimeout(timer);
        timer=setTimeout(function(){restart(el,'sdm-price-change',340)},18);
      }).observe(el,{subtree:true,childList:true,characterData:true});
    });
  }

  function chipMotion(root){
    if(reduce||!window.MutationObserver)return;
    qa('[data-sdp-stock],[data-sdp-saving],.sdp-stock,.sdp-sale-badge',root).forEach(function(el){
      var last=(el.textContent||'').trim();
      new MutationObserver(function(){
        var now=(el.textContent||'').trim();
        if(now!==last){last=now;restart(el,'sdm-chip-pop',320)}
      }).observe(el,{subtree:true,childList:true,characterData:true});
    });
  }

  function bestValueMotion(root){
    function pulse(b){
      if(!b||b.dataset.sdmPulsed)return;
      b.dataset.sdmPulsed='1';
      restart(b,'sdm-badge-pulse',680);
    }
    qa('.sdc3-best-badge',root).forEach(pulse);
    if(!window.MutationObserver)return;
    new MutationObserver(function(ms){
      ms.forEach(function(m){[].slice.call(m.addedNodes||[]).forEach(function(n){
        if(n.nodeType!==1)return;
        if(n.matches&&n.matches('.sdc3-best-badge'))pulse(n);
        qa('.sdc3-best-badge',n).forEach(pulse);
      })});
    }).observe(root,{subtree:true,childList:true});
  }

  function detailMotion(root){
    qa('.sdp-details',root).forEach(function(d){
      var s=q('summary',d);
      if(!s||q('.sdm-chevron',s))return;
      var c=document.createElement('span');
      c.className='sdm-chevron';
      c.setAttribute('aria-hidden','true');
      c.textContent='⌄';
      s.appendChild(c);
    });
  }

  function flyToCart(root){
    if(reduce)return;
    var img=q('.sdp-gallery__image',root),target=q('.header-actions a[href*="/cart"],a.editorial-action--cart,a[href="/cart"],a[href$="/cart"]');
    if(!img||!target||!img.getBoundingClientRect)return;
    var a=img.getBoundingClientRect(),b=target.getBoundingClientRect();
    if(!a.width||!a.height||!b.width)return;
    var clone=img.cloneNode(false);
    clone.className='sdm-fly-thumb';
    clone.style.left=a.left+'px';clone.style.top=a.top+'px';
    clone.style.width=Math.min(a.width,110)+'px';clone.style.height=Math.min(a.height,110)+'px';
    document.body.appendChild(clone);
    var sx=Math.min(110/a.width,1),sy=Math.min(110/a.height,1);
    var startX=a.left+(a.width-Math.min(a.width,110))/2;
    var startY=a.top+(a.height-Math.min(a.height,110))/2;
    clone.style.left=startX+'px';clone.style.top=startY+'px';
    var endX=b.left+b.width/2-(Math.min(a.width,110)*.12)/2;
    var endY=b.top+b.height/2-(Math.min(a.height,110)*.12)/2;
    if(clone.animate){
      var anim=clone.animate([
        {transform:'translate3d(0,0,0) scale('+sx+','+sy+')',opacity:.95},
        {transform:'translate3d('+((endX-startX)*.48)+'px,'+((endY-startY)*.28-24)+'px,0) scale(.62)',opacity:.9,offset:.55},
        {transform:'translate3d('+(endX-startX)+'px,'+(endY-startY)+'px,0) scale(.12)',opacity:.08}
      ],{duration:560,easing:'cubic-bezier(.2,.72,.2,1)',fill:'forwards'});
      anim.onfinish=function(){clone.remove()};
      anim.oncancel=function(){clone.remove()};
    }else setTimeout(function(){clone.remove()},600);
  }

  function confirmMotion(root){
    var form=q('form[action*="/cart/add"]',root),button=q('.sdp-add-button',root)||q('[type="submit"]',form||root);
    if(!button)return;
    ['pointerdown','touchstart'].forEach(function(name){button.addEventListener(name,function(){if(!button.disabled)button.classList.add('sdm-pressed')},{passive:true})});
    ['pointerup','pointercancel','mouseleave','touchend'].forEach(function(name){button.addEventListener(name,function(){button.classList.remove('sdm-pressed')},{passive:true})});

    var pendingAt=0,original='';
    if(form)form.addEventListener('submit',function(e){
      var s=e.submitter;
      if(s&&s.closest&&s.closest('.shopify-payment-button'))return;
      pendingAt=Date.now();
      var txt=q('[id^="AddToCartText-"]',button)||button;
      original=(txt.textContent||'Add to Deal Bag').trim();
      flyToCart(root);
    });

    var drawer=q('#ShadowsCartDrawer');
    if(!drawer||!window.MutationObserver)return;
    new MutationObserver(function(){
      if(!drawer.classList.contains('is-open')||Date.now()-pendingAt>5000)return;
      pendingAt=0;
      var txt=q('[id^="AddToCartText-"]',button)||button;
      var restore=original||txt.textContent||'Add to Deal Bag';
      button.classList.add('sdm-added');
      txt.textContent='Added ✓';
      setTimeout(function(){txt.textContent=restore;button.classList.remove('sdm-added')},1250);
    }).observe(drawer,{attributes:true,attributeFilter:['class']});
  }

  function stickyMotion(){
    var sticky=q('.sdc3-mobile-buy');
    if(!sticky||reduce||!window.MutationObserver)return;
    sticky.dataset.sdmWasVisible=sticky.hidden?'0':'1';
    var leaveTimer=0;
    new MutationObserver(function(){
      if(sticky.dataset.sdmInternal==='1'){
        delete sticky.dataset.sdmInternal;
        return;
      }
      if(!sticky.hidden){
        if(leaveTimer){clearTimeout(leaveTimer);leaveTimer=0}
        sticky.classList.remove('sdm-sticky-leave');
        sticky.dataset.sdmWasVisible='1';
        return;
      }
      if(sticky.dataset.sdmWasVisible!=='1')return;
      sticky.dataset.sdmWasVisible='0';
      sticky.dataset.sdmInternal='1';
      sticky.hidden=false;
      sticky.classList.add('sdm-sticky-leave');
      leaveTimer=setTimeout(function(){
        sticky.classList.remove('sdm-sticky-leave');
        var main=q('.sdp-add-button');
        var r=main&&main.getBoundingClientRect?main.getBoundingClientRect():null;
        var mainVisible=!!(r&&r.bottom>0&&r.top<(window.innerHeight||800));
        sticky.dataset.sdmInternal='1';
        sticky.hidden=mainVisible;
        if(!mainVisible)sticky.dataset.sdmWasVisible='1';
        leaveTimer=0;
      },175);
    }).observe(sticky,{attributes:true,attributeFilter:['hidden']});
  }

  function recommendationMotion(observer){
    var selectors='.sdc3-pair-card,.sdc3-cart-rec,.product-card,.grid-product';
    function add(scope){
      qa(selectors,scope||document).forEach(function(el,i){reveal(el,Math.min((i%5)*45,180),observer)});
    }
    add(document);
    if(!window.MutationObserver)return;
    new MutationObserver(function(ms){
      ms.forEach(function(m){[].slice.call(m.addedNodes||[]).forEach(function(n){
        if(n.nodeType!==1)return;
        if(n.matches&&n.matches(selectors))reveal(n,0,observer);
        add(n);
      })});
    }).observe(document.body,{subtree:true,childList:true});
  }

  function desktopDepth(){
    if(reduce||!window.matchMedia||!window.matchMedia('(min-width:990px)').matches)return;
    var els=qa('.template-product .sdp-reseller-note,.template-product .sdc3-mystery,.template-product .sd-trust-rows');
    if(!els.length)return;
    els.forEach(function(el){el.classList.add('sdm-depth')});
    var ticking=false;
    function update(){
      ticking=false;
      var vh=window.innerHeight||800;
      els.forEach(function(el){
        var r=el.getBoundingClientRect();
        var center=r.top+r.height/2;
        var y=Math.max(-4,Math.min(4,(center-vh/2)/vh*6));
        el.style.setProperty('--sdm-depth-y',y.toFixed(2)+'px');
      });
    }
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;raf(update)}},{passive:true});
    update();
  }

  function productReveal(root,observer){
    var list=[q('.sdp-title',root),q('.sdp-status-row',root),q('.sdp-price-wrap',root),q('.sdp-options',root),q('.sdp-form-row',root),q('.sdp-add-button',root)];
    list.filter(Boolean).forEach(function(el,i){reveal(el,i*38,null)});
    qa('.sdp-accordions,.sdp-reviews',root).forEach(function(el,i){reveal(el,i*50,observer)});
  }

  function init(){
    if(document.documentElement.dataset.sdmReady)return;
    document.documentElement.dataset.sdmReady='1';
    var observer=revealSystem();
    var root=q('[data-sdp-product]')||q('.sdp-product');
    if(root){
      classifyProduct(root);
      galleryMotion(root);
      optionMotion(root);
      priceMotion(root);
      chipMotion(root);
      bestValueMotion(root);
      detailMotion(root);
      confirmMotion(root);
      productReveal(root,observer);
      stickyMotion();
      desktopDepth();
    }
    recommendationMotion(observer);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',function(){delete document.documentElement.dataset.sdmReady;init()});
})();
